// removed by extract-text-webpack-plugin
module.exports = {"boxUser":"_1g_0p8xFRTTNT_twvGkxzR","avatar":"_2-YXPDakyYhTJYnbxKh5-S","username":"_1Nzd9fsG4ECFfoWO4lBoB","button":"_14hBwaLfeWJbXbdJt0DpOd"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/FollowUser/style.css
// module id = 488
// module chunks = 38